import { Component } from '@angular/core';
import { CStampParticulars } from '@models/imported/SagaSchema/CStampParticulars';
import { FollowupTemplate } from '@addins/callcard/components/callCardDetail/callCardDetailFollowup/FollowupTemplate';

@Component({
  templateUrl: 'CCallerBaseFollowup.html'
})
export class CCallerBaseFollowupComponent extends FollowupTemplate {
  stamp(): CStampParticulars {
    return this.data;
  }

  properties(): string[] {
    return Object.keys(this.stamp().values);
  }
}
